export default {
	'--color1v1': 'white',
	'--color1v2': 'white',
	'--color1v1Border': 'black',
	'--color1v2Border': 'black',
	'--color1Text': 'black',

	'--color2v1': 'black',
	'--color2v2': 'black',
	'--color2v1Border': 'black',
	'--color2v2Border': 'black',
	'--color2Text': 'white',

	'--inputColor': '#cacaca',
	'--inputText': 'black',

	'--disabledButton': '#e3e8ea',
	'--disabledButtonBorder': '#cad2d7',
	'--disabledButtonText': 'black',

	'--footerbg': 'black',
	'--footerText': 'white',

	'--headerColor': '#EDE7EF',
	'--headerText': 'black',
	'--navButtonBorder': 'black',

	'--backgroundColor': 'white',
	'--backgroundColorText': 'black'
} as React.CSSProperties;
